var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BRow, BCol, BAspect, BCard, BCardHeader, BCardFooter, BCardImgLazy, BCardBody, BCardSubTitle } from 'bootstrap-vue';
import { getVisualisationUrl } from 'ts/modules/frameDesigner';
let FrameResult = class FrameResult extends Vue {
    constructor() {
        super(...arguments);
        this.imgHeight = 154;
    }
    get aspect() {
        return this.rebateSize.width / this.rebateSize.length;
    }
    get visUrl() {
        return getVisualisationUrl(this.moulding.sku, this.rebateSize, this.apertureSize, {
            type: this.mountboard ? 'single' : 'none',
            top: this.mountboard,
            bottom: null,
            reveal: 3,
            borders: {
                top: this.mountWidth,
                bottom: this.mountWidth,
                left: this.mountWidth,
                right: this.mountWidth
            }
        }, true, null, 1);
    }
    get imageAlt() {
        return `${this.moulding.width_mm}mm Wide Frame to fit ${this.toFitSize.name}`;
    }
};
__decorate([
    Prop({ type: Object, required: true })
], FrameResult.prototype, "moulding", void 0);
__decorate([
    Prop({ type: Object, required: true })
], FrameResult.prototype, "rebateSize", void 0);
__decorate([
    Prop({ type: Object, required: true })
], FrameResult.prototype, "apertureSize", void 0);
__decorate([
    Prop({ type: Object, required: true })
], FrameResult.prototype, "toFitSize", void 0);
__decorate([
    Prop({ type: Number, required: false })
], FrameResult.prototype, "mountWidth", void 0);
__decorate([
    Prop({ type: Object, required: false })
], FrameResult.prototype, "mountboard", void 0);
FrameResult = __decorate([
    Component({
        components: {
            BRow, BCol, BAspect, BCard, BCardHeader, BCardFooter, BCardImgLazy, BCardBody, BCardSubTitle
        }
    })
], FrameResult);
export default FrameResult;
